import AddressForm from "./Form"

function Address() {
    return (
       <AddressForm></AddressForm>
    )
}

export default Address
